/**
 * Created by Ning Jiang on 2022-09-16.
 */

import {EnhancerReelView} from "./EnhancerReelView";
import {Serial} from "../Serial";
import {SerialGameMode} from "../server/SerialGameMode";

export class HiddenEnhancerReelView extends EnhancerReelView {

    constructor(reelId:number, positionId:number, initHeight:number) {
        super(reelId, positionId, initHeight);
    }

    protected initLock(reelId:number) {
        this._reelLock.addSprites(
            {
                name : "fs",
                textures : Serial.assetLoader.getTextures("enhancer/freespin_enhancer"),
                anchor : new PIXI.Point(0.5, 0.5)
            },
            {
                name : "fsSuper",
                textures : Serial.assetLoader.getTextures("enhancer/superfs_enhancer"),
                anchor : new PIXI.Point(0.5, 0.5)
            }
        );
    }

    public setMode():void {
        let spriteName;
        if(Serial.model.isRestore && Serial.model.initData.nextMode === SerialGameMode.CAPWIN_GAME) {
            spriteName = Serial.model.initData.evaluatedArea[4].indexOf("S2") > -1 ? "fsSuper" : "fs";
        } else {
            spriteName = Serial.model.data.nextMode.includes("SUPER") ? "fsSuper" : "fs";
        }

        this._reelLock.playSprite(spriteName, {
            duration : 0.1,
            alpha : 1
        }, {duration : 0.1, alpha : 0});
    }

    public setOpened(value:boolean):void {
        this._reelLock.visible = value;
        if(value) {
            this.setMode();
        }
    }
}